import { NavigationGuardNext, Route } from 'vue-router';
import { zccRbacService } from '@/services/zcc-rbac';
import Profile from '@/types/profiles';
import { sessionMixin } from '../../mixins/session';

const chatUrl = '/sales-chat/inbox/you';
const homeUrl = '/welcome';

const navigateTo = (path: string) => {
  try {
    (window as { navigateToUrl?: (path: string) => void }).navigateToUrl?.(path);
  } catch {
    window.location.href = path;
  }
};

const redirectUnauthorized = () => {
  const isAgent = sessionMixin.mxSession_profile.id === Profile.AGENT;

  return navigateTo(isAgent ? chatUrl : homeUrl);
};

// eslint-disable-next-line import/prefer-default-export
export const beforeEach = async (to: Route, from: Route, next: NavigationGuardNext) => {
  const authorizedProfile = !to.meta?.profiles
    || to.meta.profiles.find((el: string) => el === sessionMixin.mxSession_profile.id);

  const isRbacEnabled = await zccRbacService.isRbacEnabled();

  if (!authorizedProfile && (!isRbacEnabled || to.meta?.skipRbac)) {
    return redirectUnauthorized();
  }

  if (to.meta?.skipRbac) {
    return next();
  }

  const zccRbacResource = zccRbacService.getRouteResource(to);

  if (zccRbacResource && isRbacEnabled) {
    if (await zccRbacService.canViewResource(zccRbacResource)) {
      return next();
    }

    return redirectUnauthorized();
  }

  return next();
};
